import React, { useState, useEffect } from 'react';
import { FaPlus } from "react-icons/fa6";
import { IoArrowUndoSharp } from "react-icons/io5";
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';

const SingleInstitute = () => {
    const { id } = useParams(); // Destructure id from useParams
    const [formData, setFormData] = useState({
        country_name: '',
        country_code: '',
        institute_name: '',
        campus: '',
        website: '',
        international_contact_person: '',
        email: '',
        contact_no: '',
        status: true,
        institute_logo: ''
    });
    const [logo, setLogo] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);

    // Fetch institute data when component mounts or id changes
    useEffect(() => {
        if (id) {
            setIsEditMode(true);
            fetchInstitute();
        }
    }, [id]);

  const fetchInstitute = async () => {
    try {
        setLoading(true);
        const response = await axios.get(`https://bmrbackend.dynastymaker.com/api/institutes/${id}`);
        const instituteData = response.data.data;
        
        setFormData({
            country_name: instituteData.country?.country_name || instituteData.country_name || '',
            country_code: instituteData.country?.country_code || instituteData.country_code || '',
            institute_name: instituteData.institute_name || '',
            campus: instituteData.campus || '',
            website: instituteData.website || '',
            international_contact_person: instituteData.international_contact_person || '',
            email: instituteData.email || '',
            contact_no: instituteData.contact_no || '',
            status: instituteData.status || true,
            institute_logo: instituteData.institute_logo || '' // Add this
        });
        
        setLoading(false);
    } catch (error) {
        console.error('Error fetching institute:', error);
        toast.error('Failed to fetch institute data');
        setLoading(false);
    }
};

    const countries = [
        // ... (keep your existing countries array)
    ];

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleCountryChange = (e) => {
        const selectedCode = e.target.value;
        const selectedCountry = countries.find(c => c.code === selectedCode);
        
        if (selectedCountry) {
            setFormData({
                ...formData,
                country_name: selectedCountry.name,
                country_code: selectedCountry.code
            });
        }
    };

    const handleLogoChange = (e) => {
        setLogo(e.target.files[0]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const formDataToSend = new FormData();
            formDataToSend.append('country_name', formData.country_name);
            formDataToSend.append('country_code', formData.country_code);
            formDataToSend.append('institute_name', formData.institute_name);
            formDataToSend.append('campus', formData.campus);
            formDataToSend.append('website', formData.website);
            formDataToSend.append('international_contact_person', formData.international_contact_person);
            formDataToSend.append('email', formData.email);
            formDataToSend.append('contact_no', formData.contact_no);
            formDataToSend.append('status', formData.status);
            
            if (logo) {
                formDataToSend.append('institute_logo', logo);
            }

            let response;
            if (isEditMode) {
                // Update existing institute
                response = await axios.put(
                    `https://bmrbackend.dynastymaker.com/api/institutes/${id}`, 
                    formDataToSend, 
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Authorization': `Bearer ${localStorage.getItem('token')}`
                        }
                    }
                );
                toast.success('Institute updated successfully!');
            } else {
                // Create new institute
                response = await axios.post(
                    'https://bmrbackend.dynastymaker.com/api/institutes', 
                    formDataToSend, 
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Authorization': `Bearer ${localStorage.getItem('token')}`
                        }
                    }
                );
                toast.success('Institute added successfully!');
            }

            // Reset form if not in edit mode
            if (!isEditMode) {
                setFormData({
                    country_name: '',
                    country_code: '',
                    institute_name: '',
                    campus: '',
                    website: '',
                    international_contact_person: '',
                    email: '',
                    contact_no: '',
                    status: true
                });
                setLogo(null);
            }

        } catch (error) {
            console.error('Error:', error);
            toast.error(error.response?.data?.message || `Failed to ${isEditMode ? 'update' : 'add'} institute`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container py-4">
            <div className='d-flex align-items-center justify-content-center'>
                <div className="fs-2 w-50 mb-2 text-center bg-dark text-white">
                   Show INSTITUTE
                </div>
            </div>
            
            {loading && isEditMode ? (
                <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            ) : (
                <form onSubmit={handleSubmit}>
                    <div className="card mb-4 shadow-sm">
                        <div className="card-body">
                            <div className='text-end'>
  <Link to={`/super-admin/edit-institute/${id}`} className='btn btn-primary '>Edit</Link>
                            </div>
                            <div className="mb-3">
                                <label>Select Country</label>
                                <div className='border px-2 rounded' style={{ display: 'flex', alignItems: 'center', gap: '10px', background:'#DADADA' }}>
                                    <img
                                            src={`https://flagsapi.com/${formData.country_code}/flat/32.png`}
                                            alt="flag"
                                            style={{ width: '32px', height: '24px' }}
                                            onError={(e) => {
                                                e.target.onerror = null; 
                                                e.target.src = 'https://flagsapi.com/US/flat/32.png';
                                            }}
                                        />
                                   <input disabled className="form-control bg-transparent border-0 no-border-select" value={formData.country_name} />
                                </div>
                            </div>
                            
                            <div className="mb-3">
                                <label>Institute Name</label>
                                <input 
                                    type="text" disabled
                                    className="form-control" 
                                    name="institute_name"
                                    value={formData.institute_name}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            
                            <div className="mb-3">
                                <label>Campus</label>
                                <input 
                                    type="text" disabled
                                    className="form-control" 
                                    name="campus"
                                    value={formData.campus}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            
                            <div className="mb-3">
                                <label>Website</label>
                                <input 
                                    type="url" disabled
                                    className="form-control" 
                                    name="website"
                                    value={formData.website}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            
                            <div className="mb-3">
                                <label>Current logo:</label>
                               
                                     {formData.institute_logo && (
        <div className="mt-2">
            
            <img 
                src={`https://bmrbackend.dynastymaker.com/storage/app/public/${formData.institute_logo}`} 
                alt="Institute logo" 
                style={{ maxWidth: '200px', maxHeight: '200px', display: 'block' }}
                onError={(e) => {
                    e.target.onerror = null;
                    e.target.style.display = 'none';
                }}
            />
        </div>
    )}
                               
                            </div>
                        </div>
                    </div>

                    <div className='d-flex align-items-center justify-content-center'>
                        <div className="fs-2 w-50 mb-2 text-center bg-dark text-white">
                            Personal Details
                        </div>
                    </div>
                    
                    <div className="card shadow-sm">
                        <div className="card-body">
                            <div className="mb-3">
                                <label>International Contact Person</label>
                                <input 
                                    type="text" disabled
                                    className="form-control" 
                                    name="international_contact_person"
                                    value={formData.international_contact_person}
                                    onChange={handleInputChange}
                                    required
                                />
                                
                                <label>E-mail</label>
                                <input 
                                    type="email" disabled
                                    className="form-control" 
                                    name="email"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    required
                                />
                                
                                <label>Contact No</label>
                                <input 
                                    type="tel" disabled
                                    className="form-control" 
                                    name="contact_no"
                                    value={formData.contact_no}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>

                           

                            <div className="mt-3">
                                <Link to={'/super-admin/institute'} type="button" className="btn bg-light buttonadd">
                                    <IoArrowUndoSharp size={20} /> Back
                                </Link>
                            </div>
                        </div>
                    </div>
                </form>
            )}
        </div>
    );
};

export default SingleInstitute;